import { artsLabel } from '../data/arts';
import type { Art } from '../types';

interface ArtEmptyStateProps {
  arts: Art[];
  onSwitchArt?: () => void;
}

// Friendly placeholder shown in any view when the selected arts have no content
// yet (everything but BJJ until the other catalogs are built out).
export default function ArtEmptyState({ arts, onSwitchArt }: ArtEmptyStateProps) {
  return (
    <div className="empty-placeholder">
      <div className="empty-placeholder-card">
        <p style={{ margin: 0 }}>
          No {artsLabel(arts)} content yet. It&rsquo;s coming soon.
        </p>
        {onSwitchArt && (
          <button className="art-chip" style={{ marginTop: 12 }} onClick={onSwitchArt}>
            Change arts
          </button>
        )}
      </div>
    </div>
  );
}
